import { Controller } from 'stimulus'
import './component.scss'

// 共通画像ディレクトリから参照
import 'Images/nurikae_site/staff_introduction/819_arai_sora.webp'
import 'Images/nurikae_site/staff_introduction/819_arai_kaneyasu.webp'
import 'Images/nurikae_site/staff_introduction/819_yokoyama.webp'
import 'Images/nurikae_site/staff_introduction/831_sunada.webp'
import 'Images/nurikae_site/staff_introduction/1651_asami.jpg'
import 'Images/nurikae_site/staff_introduction/1651_ikeda.jpg'
import 'Images/nurikae_site/staff_introduction/1651_kanto.jpg'
import 'Images/nurikae_site/staff_introduction/1651_kida.jpg'
import 'Images/nurikae_site/staff_introduction/1651_koyama.jpg'
import 'Images/nurikae_site/staff_introduction/1651_kuroda.jpg'
import 'Images/nurikae_site/staff_introduction/1651_moriyama.jpg'
import 'Images/nurikae_site/staff_introduction/1651_obuchi.jpg'
import 'Images/nurikae_site/staff_introduction/1651_oigawa.jpg'
import 'Images/nurikae_site/staff_introduction/1997_ninomiya.webp'
import 'Images/nurikae_site/staff_introduction/1997_odate.webp'
import 'Images/nurikae_site/staff_introduction/1997_ozawa.webp'
import 'Images/nurikae_site/staff_introduction/1997_sato.webp'
import 'Images/nurikae_site/staff_introduction/1997_shirai.webp'
import 'Images/nurikae_site/staff_introduction/1997_shirakura.webp'
import 'Images/nurikae_site/staff_introduction/1997_yamakawa.webp'
import 'Images/nurikae_site/staff_introduction/2075_kamishita.webp'
import 'Images/nurikae_site/staff_introduction/2290_chuma.webp'
import 'Images/nurikae_site/staff_introduction/390_iwabuchi.webp'
import 'Images/nurikae_site/staff_introduction/390_tomaru.jpg'
import 'Images/nurikae_site/staff_introduction/3737_ariga.jpg'
import 'Images/nurikae_site/staff_introduction/3737_fuchu.jpg'
import 'Images/nurikae_site/staff_introduction/3737_hanyu.webp'
import 'Images/nurikae_site/staff_introduction/3737_imai.jpg'
import 'Images/nurikae_site/staff_introduction/3737_ishida.jpg'
import 'Images/nurikae_site/staff_introduction/3737_kokubun.webp'
import 'Images/nurikae_site/staff_introduction/3737_kono.jpg'
import 'Images/nurikae_site/staff_introduction/3737_nakano_s.jpg'
import 'Images/nurikae_site/staff_introduction/3737_nakano_y.jpg'
import 'Images/nurikae_site/staff_introduction/3737_okada.jpg'
import 'Images/nurikae_site/staff_introduction/3737_rikimaru.jpg'
import 'Images/nurikae_site/staff_introduction/3737_sato.jpg'
import 'Images/nurikae_site/staff_introduction/3737_sekine.jpg'
import 'Images/nurikae_site/staff_introduction/3737_yamaguchi.webp'
import 'Images/nurikae_site/staff_introduction/3737_yoshida.webp'
import 'Images/nurikae_site/staff_introduction/4611_usui.webp'
import 'Images/nurikae_site/staff_introduction/4611_yoshida.webp'
import 'Images/nurikae_site/staff_introduction/4834_harada.webp'
import 'Images/nurikae_site/staff_introduction/5089_hanawa.webp'
import 'Images/nurikae_site/staff_introduction/5089_miyanaga.webp'
import 'Images/nurikae_site/staff_introduction/5325_nakamura.webp'
import 'Images/nurikae_site/staff_introduction/5325_sano.webp'
import 'Images/nurikae_site/staff_introduction/5594_kobayashi.webp'

class StaffIntroductionTabletController extends Controller {
  static targets = [
    'track',
    'scrollbarThumb',
    'modal',
    'modalPrev',
    'modalNext',
    'modalSlide',
    'card',
    'image'
  ]

  static values = {
    total: Number
  }

  connect() {
    this.currentIndex = 0
    this.updateScrollbar()
    this.updateModalArrows()
    this.bindImageLoad()
  }

  // スクロールバー
  updateScrollbar() {
    if (!this.hasTrackTarget || !this.hasScrollbarThumbTarget) return

    requestAnimationFrame(() => {
      const scrollWidth = this.trackTarget.scrollWidth
      const clientWidth = this.trackTarget.clientWidth
      const scrollLeft = this.trackTarget.scrollLeft
      const maxScroll = scrollWidth - clientWidth

      if (maxScroll <= 0) {
        this.scrollbarThumbTarget.style.width = '100%'
        this.scrollbarThumbTarget.style.left = '0%'
        return
      }

      const thumbWidth = (clientWidth / scrollWidth) * 100
      const thumbLeft = (scrollLeft / maxScroll) * (100 - thumbWidth)

      this.scrollbarThumbTarget.style.width = `${thumbWidth}%`
      this.scrollbarThumbTarget.style.left = `${thumbLeft}%`
    })
  }

  onScroll() {
    this.updateScrollbar()
  }

  onResize() {
    this.updateScrollbar()
  }

  bindImageLoad() {
    if (!this.hasImageTarget) return

    this.imageTargets.forEach((img) => {
      if (img.complete) {
        this.updateScrollbar()
      } else {
        img.addEventListener('load', () => this.updateScrollbar())
      }
    })
  }

  // モーダル開閉
  openModal(event) {
    const card = event.currentTarget
    const index = parseInt(card.dataset.staffIndex, 10)
    this.showSlide(index, false)
    this.modalTarget.classList.add('is-open')
    document.body.style.overflow = 'hidden'
  }

  closeModal() {
    this.modalTarget.classList.remove('is-open')
    document.body.style.overflow = ''
  }

  closeOnEscape(event) {
    if (event.key === 'Escape' && this.modalTarget.classList.contains('is-open')) {
      this.closeModal()
    }
  }

  // モーダルスライド
  modalPrevSlide() {
    if (this.currentIndex > 0) {
      this.showSlide(this.currentIndex - 1)
    }
  }

  modalNextSlide() {
    if (this.currentIndex < this.totalValue - 1) {
      this.showSlide(this.currentIndex + 1)
    }
  }

  showSlide(index, animate = true) {
    this.modalSlideTargets.forEach((slide, i) => {
      if (!animate) {
        slide.classList.add('no-transition')
      }

      slide.classList.remove('is-active', 'is-prev', 'is-next')

      if (i === index) {
        slide.classList.add('is-active')
      } else if (i < index) {
        slide.classList.add('is-prev')
      } else {
        slide.classList.add('is-next')
      }

      if (!animate) {
        requestAnimationFrame(() => {
          slide.classList.remove('no-transition')
        })
      }
    })

    this.currentIndex = index
    this.updateModalArrows()
  }

  updateModalArrows() {
    if (this.hasModalPrevTarget) {
      this.modalPrevTarget.disabled = this.currentIndex === 0
    }
    if (this.hasModalNextTarget) {
      this.modalNextTarget.disabled = this.currentIndex === this.totalValue - 1
    }
  }
}

// StimulusJSに登録
window.Stimulus.register('staff-introduction-tablet', StaffIntroductionTabletController)
